<template>
  <div id="app">
    <HelloWorld msg="Lidy Sample Projects from Vue.js"/>
  </div>
</template>

<script>
import HelloWorld from './components/HelloWorld.vue'

export default {
  name: 'App',
  components: {
    HelloWorld
  },
  mounted() {
    this.checkDomain();
  },
  methods: {
    checkDomain() {
      if (window.location.hostname.includes('subfac')) {
        window.location.replace('https://www.subfac.com');
      }
    }
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
